import { render, staticRenderFns } from "./Service_calendar.vue?vue&type=template&id=19e96c02&scoped=true&"
import script from "./Service_calendar.vue?vue&type=script&lang=js&"
export * from "./Service_calendar.vue?vue&type=script&lang=js&"
import style0 from "./Service_calendar.vue?vue&type=style&index=0&id=19e96c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e96c02",
  null
  
)

export default component.exports